import { NoMembership } from "@shared/graphql.apollo";

export const mapHotJarMembershipTerm = (
  id: string | undefined,
  duration: string | undefined
): string => {
  if (!id || id === NoMembership.id || !duration) return "";

  return duration === "none" ? "unknown" : duration;
};
